module.exports = __webpack_public_path__ + "img/EMERALD.1ab328c1.png";